import { getAgreementViewablePositions } from '@flow/libs/oneflow-client/agreements';
import type { FormData } from './internal-reminder-create-types';

// TODO: Remove this type when oneflow-client/agreements is converted to typescript
// For some reason when we get the type of the function from the library it returns the type of the parameters instead
// This is probably because of the flow types in the oneflow-client/agreements file
type GetAgreementViewablePositionsParams = typeof getAgreementViewablePositions;

type GetAgreementViewablePositions = (params: GetAgreementViewablePositionsParams) => Promise<{
  collection: Oneflow.Position[];
}>;

const getRecipientsWithAccessInfo = async (formData: FormData) => {
  const contractId = formData.contractFieldOption.contract.id;

  const toRecipients = formData.recipients.map((recipient) => recipient.id);

  let validRecipients = {
    collection: formData.recipients,
  };
  try {
    // TODO: remove the type cast when oneflow-client/agreements is converted to typescript
    validRecipients = await (
      getAgreementViewablePositions as unknown as GetAgreementViewablePositions
    )({
      contractId,
      positionIds: toRecipients,
    });
  } catch {
    // There is possiblity that limited user or normal user don't have access
    // To this endpoint (403)
    // Update: No need to worry about this scenario.
    // In create modal the normal user/limited users will get the contracts that they has access to
    // As soon as they loose access, the event becomes read-only where we don't use this endpint
  }

  const validRecipientIds = validRecipients.collection.map((recipient) => recipient.id);
  const recipientsWithAccessInfo = formData.recipients.map((recipient) => ({
    ...recipient,
    needsAccess: !validRecipientIds.includes(recipient.id),
  }));

  return recipientsWithAccessInfo;
};

export default getRecipientsWithAccessInfo;
